import { SET_SOCIAL_DATA } from "../types";

export default (state = {}, action = {}) => {
  if (action.type === SET_SOCIAL_DATA) {
    return action.payload;
  }
  return state;
};
